<template>
  <v-dialog
    v-model="dialog"
    width="50vw"
    scrollable
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
  >
    <v-card>
      <v-card-title class="text-start headline">
        <v-row>
          <v-col v-if="strain">
            Actualizar cepa
            <span class="primary--text">{{
              this.strain.identificationName
            }}</span></v-col
          >
          <v-col v-else> Nueva cepa </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" xl="6" lg="6" v-if="!strain">
                <v-autocomplete
                  v-model="identification"
                  :search-input.sync="search"
                  :items="identificationsFounded"
                  :loading="loader"
                  return-object
                  outlined
                  dense
                  clearable
                  item-text="name"
                  no-data-text="No se ha encontrado"
                  label="Selecciona microorganismo"
                  :rules="validation('microorganismo', 'M')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xl="6" lg="6" v-if="!strain">
                <v-autocomplete
                  label="Selecciona tipo de microorganismo"
                  :items="moTypes"
                  v-model="moType"
                  dense
                  outlined
                  return-object
                  :rules="validation('tipo', 'M')"
                  :disabled="typeof identification == 'object'"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xl="6" lg="6" v-if="!strain">
                <v-text-field
                  outlined
                  dense
                  label="Código de microorganismo"
                  v-model="code"
                  :rules="validation('código', 'M')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6" lg="6" v-if="!strain">
                <v-text-field
                  outlined
                  dense
                  label="Nomenclatura de microorganismo"
                  @input="convertToUpperCase"
                  v-model="nomenclature"
                  :rules="validation('nomenclatura', 'F')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="6" lg="6">
                <v-text-field
                  outlined
                  dense
                  label="ID de secuencia"
                  v-model="sequenceId"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <!-- Actions -->
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                @click="dialog = false"
                depressed
                dark
                block
                color="gray"
                :disabled="loading"
              >
                Cerrar
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                :loading="loading"
                depressed
                block
                color="primary"
                @click="add"
              >
                <span v-if="strain"> Actualizar </span>
                <span v-else> Agregar </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
// Validations
import {
  requiredFValidation,
  requiredValidation,
  requiredMultiple,
} from "@/helpers/validations.js";
// library
import axios from "axios";
export default {
  props: {
    value: Boolean,
    strain: Object,
  },
  data() {
    return {
      moTypes: [
        {
          text: "Hongo",
          value: "fungi",
        },
        {
          text: "Bacteria",
          value: "bacteria",
        },
      ],
      moType: null,
      identification: null,
      user: JSON.parse(localStorage.getItem("user")),
      search: null,
      identificationsFounded: [],
      loader: false,
      loading: false,
      sequenceId: null,
      code: null,
      nomenclature: null,
    };
  },
  computed: {
    ...mapState("bioactives", ["bioactiveSelected", "reactivation"]),
    ...mapState("strain", [
      "shape",
      "margin",
      "elevation",
      "surface",
      "opacity",
      "color",
      "fungiColor",
      "fungiTexture",
      "growth",
    ]),
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    if (this.strain) {
      this.code = this.strain.identificationCode;
      this.nomenclature = this.strain.identification.nomenclature;
      this.sequenceId = this.strain.sequenceId;
    }
  },
  methods: {
    ...mapActions("bioactives", [
      "searchIdentification",
      "addIdentification",
      "addBioactiveStrain",
      "updateBioactiveStrain",
    ]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    ...mapMutations("bioactives", [
      "SET_FETCH_PRESERVED_LIST",
      "SET_FETCH_BIO_LIST",
    ]),
    // Form validations
    validation(name, type) {
      if (type === "F") {
        return requiredFValidation(name);
      } else {
        return requiredValidation(name);
      }
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    convertToUpperCase() {
      this.nomenclature = this.nomenclature.toUpperCase();
    },
    async add() {
      if (!this.strain) {
        if (this.$refs.form.validate()) {
          try {
            this.loading = true;
            let identification = await this.getIdentification();

            let payload = {
              identification: identification,
              sequenceId: this.sequenceId,
              code: this.code,
              nomenclature: this.nomenclature,
            };
            let response = await this.addBioactiveStrain(payload);
            if (response) {
              if (!response.error) {
                this.SET_FETCH_PRESERVED_LIST(true);
                this.SET_FETCH_BIO_LIST(true);
                this.loading = false;
                this.dialog = false;
                this.$swal({
                  icon: "success",
                  title: `Microorganismo agregado`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else {
                this.loading = false;
                this.$swal({
                  icon: "error",
                  title: `ALGO SALIO MAL AL CREAR MIROORGANISMO`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
            } else {
              this.loading = false;
              this.$swal({
                icon: "error",
                title: `ALGO SALIO MAL AL CREAR MIROORGANISMO`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } catch (e) {
            this.loading = false;
            console.log(e);
            this.$swal({
              icon: "error",
              title: `ALGO SALIO MAL AL CREAR MIROORGANISMO`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } else {
        if (this.$refs.form.validate()) {
          try {
            this.loading = true;
            let payload = {
              _id: this.strain._id,
              sequenceId: this.sequenceId,
            };
            let response = await this.updateBioactiveStrain(payload);
            if (response) {
              if (!response.error) {
                this.SET_FETCH_PRESERVED_LIST(true);
                this.SET_FETCH_BIO_LIST(true);
                this.loading = false;
                this.dialog = false;
                this.$swal({
                  icon: "success",
                  title: `Microorganismo actualizado`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else {
                this.loading = false;
                this.$swal({
                  icon: "error",
                  title: `ALGO SALIO MAL AL CREAR MIROORGANISMO`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
            } else {
              this.loading = false;
              this.$swal({
                icon: "error",
                title: `ALGO SALIO MAL AL CREAR MIROORGANISMO`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } catch (e) {
            this.loading = false;
            console.log(e);
            this.$swal({
              icon: "error",
              title: `ALGO SALIO MAL AL CREAR MIROORGANISMO`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      }
    },
    async getIdentification() {
      try {
        if (typeof this.identification !== "object" && this.search) {
          // New.
          this.identification = {
            name: this.search,
            moType: this.moType.value,
          };
          const response = await this.addIdentification(this.identification);
          if (response.error) throw response;
          return response.IDENTIFICATION;
        } else {
          // identification selected
          return this.identification;
        }
      } catch (e) {
        console.log("Error on getIdentificationId", e);
        return e;
      }
    },
  },
  watch: {
    async search(val) {
      if (!val) return;
      else {
        this.loader = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());

        try {
          const response = await this.searchIdentification({
            name: val,
          });
          if (response.error) throw response;

          this.identificationsFounded = response.strains;
        } catch (e) {
          console.log(e);
        }
        this.loader = false;
      }
    },
    identification(value) {
      if (value) {
        if (value.moType) {
          if (value.moType == "fungi") {
            this.moType = this.moTypes[0];
          } else {
            this.moType = this.moTypes[1];
          }
        } else {
          this.moType = null;
        }
      } else {
        this.moType = null;
      }
    },
  },
};
</script>
